import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FeaturesService } from 'src/app/shared/services/features.service';
import { Features } from "../../shared/enums/Features";
import { map, take } from 'rxjs/operators';

export const ReadFromSASSResolver: ResolveFn<boolean> = () => {
  const featuresService = inject(FeaturesService);

  return featuresService.getFeatures().pipe(
    map((features) => {
      const target = features.find(f => f.name === Features.ReadDataFromSASS);
      return target?.enabled === true;
    }),
    take(1) // resolve only once
  );
};